import React, { useState, useEffect } from 'react';
import { Building2, TrendingUp, Award, CheckCircle, Users, Target } from 'lucide-react';
import './BenefitsCarousel.css';

export const BenefitsCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const benefits = [
    {
      icon: Building2,
      title: 'Schnelle Handlungsfähigkeit',
      description: 'Dank unserer schlanken Strukturen und langjährigen Erfahrung können wir rasch auf Marktveränderungen reagieren. Unsere Entscheidungswege sind kurz, was uns ermöglicht, Chancen zeitnah zu nutzen und Projekte effizient voranzutreiben.',
      image: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/ta45d3rq_Krahn.webp'
    },
    {
      icon: Users,
      title: 'Individuelle Beratung',
      description: 'Jedes Projekt ist einzigartig. Wir nehmen uns die Zeit, Ihre spezifischen Bedürfnisse und Ziele zu verstehen. Mit massgeschneiderten Lösungen und persönlicher Betreuung stehen wir Ihnen vom ersten Gespräch bis zur erfolgreichen Realisierung zur Seite.',
      image: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/s4sfe730_Qualit%C3%A4t.webp'
    },
    {
      icon: Target,
      title: 'Flexibilität',
      description: 'Immobilienprojekte verlaufen selten nach Plan. Unsere flexible Herangehensweise ermöglicht es uns, auf unvorhergesehene Herausforderungen zu reagieren und Lösungen zu finden, die sowohl wirtschaftlich als auch praktisch sind.',
      image: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/fa5ygqyz_Schweisssen.webp'
    },
    {
      icon: Award,
      title: 'Qualität',
      description: 'Höchste Standards in Planung, Ausführung und Materialwahl sind für uns selbstverständlich. Wir arbeiten ausschliesslich mit geprüften Partnern zusammen und setzen auf nachhaltige Lösungen, die langfristige Wertschöpfung garantieren.',
      image: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/uew7tqpj_Elektroinstallation.webp'
    },
    {
      icon: CheckCircle,
      title: 'Langfristige Partnerschaft',
      description: 'Wir denken über einzelne Projekte hinaus. Unser Ziel ist es, langfristige Partnerschaften aufzubauen, die auf Vertrauen, Transparenz und gegenseitigem Erfolg basieren. Viele unserer Kunden begleiten wir über Jahre hinweg.',
      image: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/4oktkzz3_Baumeisterarbeiten.webp'
    },
    {
      icon: TrendingUp,
      title: 'Regionale Expertise',
      description: 'Als in der Ostschweiz verwurzeltes Unternehmen kennen wir die regionalen Besonderheiten, Marktdynamiken und rechtlichen Rahmenbedingungen aus erster Hand. Unser Netzwerk und unsere Marktkenntnisse sind Ihr Vorteil.',
      image: 'https://customer-assets.emergentagent.com/job_realestate-ai-blog/artifacts/tzk72ew0_Mehrfamiilenhaus%20im%20Bau.webp'
    }
  ];

  // Auto-play every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % benefits.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [benefits.length]);

  return (
    <section className="benefits-carousel-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
        <h2 className="text-4xl md:text-5xl font-normal text-white text-center mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          Was wir bieten.
        </h2>
        <p className="text-xl text-gray-200 text-center mb-16 max-w-3xl mx-auto">
          Entwickeln, bewerten und verkaufen Sie Immobilien mit einem erfahrenen Partner an Ihrer Seite
        </p>
        
        <div className="benefits-tabs-container">
          {/* Left side: Tabs */}
          <div className="benefits-tabs-list">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`benefit-tab ${index === activeIndex ? 'benefit-tab-active' : ''}`}
                >
                  <div className="benefit-tab-icon">
                    <Icon size={24} />
                  </div>
                  <span className="benefit-tab-title">{benefit.title}</span>
                </button>
              );
            })}
          </div>

          {/* Right side: Content */}
          <div className="benefits-content">
            <div className="benefits-content-image">
              <img
                src={benefits[activeIndex].image}
                alt={benefits[activeIndex].title}
                className="benefit-image"
              />
            </div>
            <h3 className="benefits-content-title">{benefits[activeIndex].title}</h3>
            <p className="benefits-content-description">{benefits[activeIndex].description}</p>
          </div>
        </div>

        {/* Pagination dots */}
        <div className="benefits-pagination">
          {benefits.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`pagination-dot ${index === activeIndex ? 'pagination-dot-active' : ''}`}
              aria-label={`Go to benefit ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
